module.exports = __webpack_public_path__ + "img/C8.9dd774e9.png";